<footer class="footer">
  <div class="container">
    <div class="row">
      <div class="col-12 col-sm-6"> <span>© {{year}} UNT Health Fort Worth</span></div>
      <div class="col-12 col-sm-6 text-right"><a href="https://www.unthsc.edu/privacy-policy/" target="_blank">Privacy Policy</a></div>
    </div>
  </div>
</footer>